import { ApiAnnuaireService } from './../services/api-annuaire.service';

import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from './../../../environments/environment';

@Component({
  selector: 'app-annuaire-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.css'],
  providers: []
})
export class FormComponent implements OnInit {
  annuaireForm;

  cities : Array<any> = [];
  rubriques : Array<any> = [];
  sousRubriques : Array<any> = [];
  categories : Array<any> = [];
  
  entreprises;
  total = 0;

  base_url = '';

  loading = false;

  constructor(public _apiService : ApiAnnuaireService, private _router : Router, private _activatedRoute : ActivatedRoute) {
    this.base_url = environment.base_url;
   }

  ngOnInit() {
    this._activatedRoute.data
      .subscribe((data: { results: any }) => {
        this.cities = data.results.cities;
        this.rubriques = data.results.rubriques;
      });

      /*this._apiService.setAnnuaireFormDatas(
        '',
        '',
        '',
        '',
        ''
      );*/

    this._apiService.getEntreprisesByFilter(1).then(results => {
      if (results) {
        this.entreprises = results.results;
        this.total = results.total.nb;
      }
    });

    // Initialisation des règles des champs
    this.initForm();
  }

  initForm() {
    var saved = this._apiService.getAnnuaireFormDatas();

    console.log('saved : ', saved);

    this.annuaireForm = new FormGroup({
      'entreprise' : new FormControl(saved.entreprise, []),
      'rubrique' : new FormControl(saved.rubrique, []),
      'sousRubrique' : new FormControl(saved.sousRubrique, []),
      'ville' : new FormControl(saved.ville, []),
      'categorie' : new FormControl(saved.categorie, [])
    });

    this.onChangedRubrique(saved.rubrique, true);
    this.onChangedSousRubrique(saved.sousRubrique, true);

  }

  onChangedRubrique(newValue, trigger=false) {
    if(trigger == false) {
      this.annuaireForm.controls['sousRubrique'].setValue('');
    }
    
    if(newValue !== "") {
      this._apiService.getSubRubrique(newValue).then(results => {
        if (results) {
          this.sousRubriques = results;
        }
      });
    } else {
      this.sousRubriques = [];
    }
  }

  onChangedSousRubrique(newValue, trigger = false) {
    if (trigger == false) {
      this.annuaireForm.controls['categorie'].setValue('');
    }

    if(newValue !== "") {
      this._apiService.getCategories(newValue).then(results => {
        if (results) {
          this.categories = results;
        }
      });
    } else {
      this.categories = [];
    }
  }

  onSubmit() {
    this.loading = true;

    // MAJ du sujet 
    this._apiService.setAnnuaireFormDatas(
      this.annuaireForm.value.rubrique,
      this.annuaireForm.value.sousRubrique,
      this.annuaireForm.value.categorie,
      this.annuaireForm.value.entreprise,
      this.annuaireForm.value.ville
    );

    this._apiService.getEntreprisesByFilter(1).then(results => {
      if (results) {
        this.entreprises = results.results;
        this.total = results.total.nb;

        this.loading = false;
      } 
    });

    console.log('- ANNUAIRE DATAS -', this._apiService.getAnnuaireFormDatas(), this.entreprises);

    // Redirection vers le isting des résultats : offset par défaut 1
    //this._router.navigate(['/annuaire/listing/1']);
  }

}



// WEBPACK FOOTER //
// ./src/app/annuaire/form/form.component.ts